import { faCalendarStar } from "@fortawesome/pro-duotone-svg-icons/faCalendarStar";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_TRIGGERS_LINK: Breadcrumb = {
  icon: faCalendarStar,
  name: "Triggers",
  to: "/dashboard/triggers",
};
